import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'workflow', controller: 'workflowManagement') => ({
	GetProcessRequestParameters: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProcessRequestParameters'
	}),
	GetApprovalCount: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetApprovalCount'
	}),
	GetApprovalCounts: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetApprovalCounts'
	}),
	GetApprovals: new PostMethod<Array<any>, any>({
		service,
		controller,
		method: 'GetApprovals'
	}),
	GetDrafts: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDrafts'
	}),
	GetDraftCounts: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetDraftCounts'
	}),
	GetDraftCount: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDraftCount'
	}),
	GetNotifications: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetNotifications'
	}),
	GetNotificationCounts: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetNotificationCounts'
	}),
	GetNotificationCount: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetNotificationCount'
	}),
	GetSents: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetSents'
	}),
	GetSentCounts: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetSentCounts'
	}),
	GetSentCount: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetSentCount'
	}),
	SendMessage: new PostMethod<string, any>({
		service,
		controller,
		method: 'SendMessage'
	}),
	GetInboxMessages: new GetMethod<any[], null>({
		service,
		controller,
		method: 'GetInboxMessages'
	}),
	GetDeletedMessages: new GetMethod<any[], null>({
		service,
		controller,
		method: 'GetDeletedMessages'
	}),
	GetMessagesCounts: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetMessagesCounts'
	}),
	GetSentMessages: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetSentMessages'
	}),
	MarkMessageAsRead: new PostMethod<string, any>({
		service,
		controller,
		method: 'MarkMessageAsRead'
	}),
	GetNoteItems: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetNoteItems'
	}),
	GetProjects: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetProjects'
	}),
	GetProjectCount: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProjectCount'
	}),
	DeleteMessage: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteMessage'
	}),
	GetHistoryCounts: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetHistoryCounts'
	}),
	GetHistory: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetHistory'
	}),
	GetWorkflowItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetWorkflowItems'
	}),
	GeteBAWorkflowItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'GeteBAWorkflowItems'
	}),
	GeteBAWorkflowItemUrl: new PostMethod<any, any>({
		service,
		controller,
		method: 'GeteBAWorkflowItemUrl'
	}),
	GetDraftDocuments: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDraftDocuments'
	}),
	GetCurrentProcessRequest: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetCurrentProcessRequest'
	}),
	GetProcessByProcIdAndReqId: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProcessByProcIdAndReqId'
	}),
	DeleteDraftDocument: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteDraftDocument'
	}),
	GetFlowFormByDocumentId: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFlowFormByDocumentId'
	})
});

export { getMethods };
